"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
var guestia_storage_1 = require("./guestia_storage");
var USER_SCHEMA = { id: undefined, email: undefined, settings: {} };
var Settings = /** @class */ (function () {
    function Settings(apiClient, JWT, _a) {
        var _b = _a.storage, storage = _b === void 0 ? 'cookie' : _b, _c = _a.schema, schema = _c === void 0 ? {} : _c;
        this.isStateReady = false;
        this.sync = this.sync.bind(this);
        this.apiClient = apiClient;
        this.storage = new guestia_storage_1["default"](storage, schema);
        this.state = this.load();
        this.JWT = JWT;
    }
    Settings.prototype.loadState = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            if (!_this.JWT.get()) {
                reject('User is not authorized');
                return;
            }
            _this.apiClient
                .get('/user/settings', {})
                .then(function (data) {
                _this.handleResponse(data.user);
                _this.isStateReady = true;
                resolve({ settings: _this.state });
            })["catch"](function (data) {
                if (data && data.status && data.status === 404) {
                    // NOTE: new user has no settings to get, but old settings can be saved in storage,
                    //       so we should reset it to empty state
                    _this.reset();
                    _this.state = _this.load();
                    _this.isStateReady = true;
                    resolve(_this.state);
                }
            });
        });
    };
    Settings.prototype.get = function (key) {
        return this.state[key] || this.state.settings[key];
    };
    Settings.prototype.getAll = function () {
        return __assign({}, this.state.settings, { email: this.state.email });
    };
    Settings.prototype.set = function (key, value) {
        var keys = this.storage.keys();
        if (key in USER_SCHEMA) {
            this.state[key] = value;
        }
        else if (keys.indexOf(key) >= 0) {
            this.state.settings[key] = value;
        }
        else {
            throw new Error("Unknown property " + key);
        }
        this.storage.set(key, value);
    };
    Settings.prototype.sync = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            if (!_this.isStateReady) {
                reject('User settings state is not ready');
                return;
            }
            if (!_this.JWT.get()) {
                reject('User is not authorized');
                return;
            }
            var params = {
                user: {
                    settings: _this.state.settings,
                    email: _this.state.email
                }
            };
            _this.apiClient
                .post('/user/settings', params)
                .then(function (data) {
                _this.handleResponse(data.user);
                resolve(_this.state);
            })["catch"](reject);
        });
    };
    Settings.prototype.load = function () {
        var _this = this;
        var result = { settings: {} };
        this.storage.keys().forEach(function (key) {
            if (key in USER_SCHEMA) {
                result[key] = _this.storage.get(key);
            }
            else {
                result.settings[key] = _this.storage.get(key);
            }
        });
        return result;
    };
    Settings.prototype.reset = function () {
        var _this = this;
        this.storage.keys().forEach(function (key) {
            _this.storage.remove(key);
        });
    };
    Settings.prototype.handleResponse = function (user) {
        var _this = this;
        if ('email' in user) {
            this.state.email = user.email;
        }
        this.state.settings = this.extendSettings(user.settings);
        this.storage.set('email', this.state.email);
        this.storage.keys().forEach(function (key) {
            _this.storage.set(key, _this.state.settings[key]);
        });
    };
    Settings.prototype.extendSettings = function (settings) {
        var _this = this;
        var newSettings = {};
        this.storage.keys().forEach(function (key) {
            if (!(key in USER_SCHEMA)) {
                newSettings[key] = key in settings ? settings[key] : _this.state.settings[key];
            }
        });
        return newSettings;
    };
    return Settings;
}());
exports["default"] = Settings;
